import React, { useState } from "react";
import {
  Container,
  Form,
  InputGroup,
  Button,
  Row,
  Col,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import { useLocation,useHistory } from "react-router";
import queryString from "query-string";
import { authFetch } from "../auth";

export var seachRealt = [];

const DetailedSearch = () => {
  const [input, setInput] = useState({
    searchCountry: 0,
    searchCompany: "",
    searchPri: "",
    searchItem: "",
  });

  const { searchCountry, searchCompany, searchPri, searchItem } = input;

  const history = useHistory();

  const onChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (e) => {
    //console.log(searchCountry);
    //e.preventDefault();
    var querySearch_Info =
      "/search-result?searchCountry=" +
      searchCountry +
      "&searchCompany=" +
      searchCompany +
      "&searchItem=" +
      searchItem;
    history.push(querySearch_Info);
    window.location.reload();
  };

  return (
    <div
      className="position-absolute"
      style={{ zIndex: "200", left: "12px", right: "10px" }}
    >
      <Form className="bg-white rounded border p-3">
        <h3>
          <FormattedMessage id="detail" />
        </h3>
        <div key="radio" className="mb-3">
          <strong>
            <FormattedMessage id="country" />:{" "}
          </strong>
          <Form.Check
            inline
            type="radio"
            id="checkbox-1"
            label="한국"
            name="searchCountry"
            value={1}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="러시아"
            name="searchCountry"
            value={2}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="우즈베키스탄"
            name="searchCountry"
            value={3}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="키르기스스탄"
            name="searchCountry"
            value={4}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="카자흐스탄"
            name="searchCountry"
            value={5}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="우크라이나"
            name="searchCountry"
            value={6}
            onChange={onChange}
          />
          <Form.Check
            inline
            type="radio"
            id="checkbox-2"
            label="벨라루스"
            name="searchCountry"
            value={7}
            onChange={onChange}
          />
        </div>
        <Form.Group>
          <Form.Label>
            <FormattedMessage id="companyNm" />
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="기업명"
            name="searchCompany"
            value={searchCompany}
            onChange={onChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <FormattedMessage id="itemNm" />
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="상품"
            name="searchItem"
            value={searchItem}
            onChange={onChange}
          />
        </Form.Group>
        <div className="py-2 text-right">
          <Button type="clear" className="mx-2">
            <FormattedMessage id="reset" />
          </Button>
          <Button type="submit" onClick={onSubmit}>
            <FormattedMessage id="search" />
          </Button>
          <Button type="submit" >
            <FormattedMessage id="group" />
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default () => {
  const [show, setShow] = useState(false);

  const location = useLocation();
  const query = queryString.parse(location.search);
  const useCategory = query.useCategory;

  const [input, setInput] = useState({
    searchText: "",
    searchInfo: "0",
  });

  const history = useHistory();

  const onChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const { searchText, searchInfo } = input;

  const onButtonClick = () => {
    setShow((prev) => !prev);
  };

  const onButtonSearch = () => {
    //setShow((prev) => !prev);

    if(useCategory == undefined) {
      var querySearch_Info =
        "/search-result?searchInfo=" + searchInfo + "&searchText=" + searchText;
      history.push(querySearch_Info);
      window.location.reload();
    }
    else {
      var querySearch_Info =
        "/search-result?searchInfo=" + searchInfo + "&searchText=" + searchText + "&useCategory=" + useCategory;
      history.push(querySearch_Info);
      window.location.reload();
    }
  };

  const onButtonAll = () => {
    //setShow((prev) => !prev);

    fetch(`api/company/allCreate`, {
      method: "post",
    })
      .then((resp) => resp.json)
      .then((resp) => {
        if (resp.resend) {
          console.log("success!");
        }
      });
  };

  const onButtonGroup = () => {
    //setShow((prev) => !prev);
    /*
    authFetch("api/searchGruop", {
      method: "post",
      body: JSON.stringify({
        "searchCompany" : searchText,
      }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          console.log(resp);
        }
    });
    */
    var querySearch_Info =
      "/search-result?searchGruop=" + searchText;
    history.push(querySearch_Info);
    window.location.reload();
  };

  return (
    <Container fluid className="pl-5 py-2 mb-4 bg-light position-relative">
      <div style={{ width: "90%" }}>
        <Form>
          <Row>
            <Col lg={2}>
              <Form.Select
                aria-label="Default select example"
                name="searchInfo"
                value={searchInfo}
                onChange={onChange}
              >
                <FormattedMessage id="companyNm">
                  {(message) => <option value="0">{message}</option>}
                </FormattedMessage>
                <FormattedMessage id="suppliers">
                  {(message) => <option value="6">{message}</option>}
                </FormattedMessage>
                <FormattedMessage id="keyword">
                  {(message) => <option value="7">{message}</option>}
                </FormattedMessage>
              </Form.Select>
            </Col>
            <Col className="position-relative">
              <Form.Group id="topbarSearch">
                <InputGroup
                  id="search_input"
                  className="input-group-merge search-bar"
                >
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name="searchText"
                    value={searchText}
                    onChange={onChange}
                  />
                  <InputGroup.Text onClick={onButtonClick} className="bg-dark">
                    <FontAwesomeIcon icon={faAngleDown} />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col lg={2} className="p-0">
              <Button type="button" onClick={onButtonSearch} className="w-75">
                <FormattedMessage id="search" />
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Container>
  );
};
